<div class="dialog">
    <h2 mat-dialog-title>{{ title }}</h2>

    <mat-dialog-content>
        {{ content }}
    </mat-dialog-content>

    <div class="dialog__actions buttons-container">
        <button class="button-size secondary-button" mat-raised-button mat-dialog-close>
            {{ cancelBtnText }}
        </button>

        <button class="button-size" mat-raised-button color="primary" cdkFocusInitial (click)="continue()">
            {{ okayBtnText }}
        </button>
    </div>
</div>